import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	moreOptions: {
		id: 'project-create-importer-upload-flow.project-create-screen.new-project-create-more-options.more-options',
		defaultMessage: 'Show more',
		description:
			'Heading for more options accordion to show fields to configure project key and project type',
	},
	hideMoreOptions: {
		id: 'project-create-importer-upload-flow.project-create-screen.new-project-create-more-options.hide-more-options',
		defaultMessage: 'Hide more',
		description:
			'Heading for hide accordion to show fields to configure project key and project type',
	},
	projectType: {
		id: 'project-create-importer-upload-flow.project-create-screen.new-project-create-more-options.project-type',
		defaultMessage: 'Project type',
		description: 'Field header for the project type field',
	},
	companyManagedLabel: {
		id: 'project-create-importer-upload-flow.project-create-screen.new-project-create-more-options.company-managed-label',
		defaultMessage: 'Company-managed',
		description:
			'Label for dropdown where user can change the current project type into the Company-managed one',
	},
	teamManagedLabel: {
		id: 'project-create-importer-upload-flow.project-create-screen.new-project-create-more-options.team-managed-label',
		defaultMessage: 'Team-managed',
		description:
			'Label for dropdown where user can change the current project type into the Team-managed one',
	},
	adminOnlyLozenge: {
		id: 'project-create-importer-upload-flow.project-create-screen.new-project-create-more-options.admin-only-lozenge',
		defaultMessage: 'Administrators only',
		description:
			'Message in lozenge to indicate that an option inside dropdown is only available for Administrators',
	},
	companyManagedDescription: {
		id: 'project-create-importer-upload-flow.project-create-screen.new-project-create-more-options.company-managed-description',
		defaultMessage:
			'For teams who work with others across many projects in a standard way that’s set by your Jira admins. Encourage and promote organizational best practices through shared configuration.',
		description: 'Description of team managed project',
	},
	teamManagedDescription: {
		id: 'project-create-importer-upload-flow.project-create-screen.new-project-create-more-options.team-managed-description',
		defaultMessage:
			'For teams who want to control their own working processes and practices in a self-contained space. The configuration is simpler and gives project admins more control over set up without involving a Jira admin. Settings do not impact other projects.',
		description: 'Description of team managed project',
	},
	cannotCreateCompanyManagedProjectTooltipMessage: {
		id: 'project-create-importer-upload-flow.project-create-screen.new-project-create-more-options.cannot-create-company-managed-project-tooltip-message',
		defaultMessage:
			'Only your Jira admin can create company-managed projects. Contact them for assistance.',
		description:
			'Tooltip message to show on disabled-company managed option if user is trying to create company-managed project',
	},
	cannotCreateTeamManagedProjectTooltipMessage: {
		id: 'project-create-importer-upload-flow.project-create-screen.new-project-create-more-options.cannot-create-team-managed-project-tooltip-message',
		defaultMessage: "We currently don't support Team Managed Projects",
		description:
			'Tooltip message to show on disabled-team managed option if user is trying to create team-managed project',
	},
	contactAdminCta: {
		id: 'project-create-importer-upload-flow.project-create-screen.new-project-create-more-options.contact-admin-cta',
		defaultMessage: 'Contact admin',
		description: 'CTA to contact admin',
	},
});
